export default __webpack_public_path__ + "static/media/safer.bb6fa6db.svg";